import React from 'react'
import { connect } from 'react-redux'
import { Entity } from '../app/entity'
import Navigator from '../app/navigator'
import { GraphEntity } from '../domain/GraphEntity'
import { PercentileType } from '../domain/ReportCriteria'
import { ApplicationState } from '../redux/ApplicationState'
import TooltipGraph from './graph/tooltip-graph'
import Snapshot from './snapshot/snapshotModel'
import { getMonitorGraph } from '../redux/monitor/MonitorState'
import { TidewaysContext } from '../app/context'

interface OwnProps {
    responseType: PercentileType
    service?: string
    shareTimeslot?: (activeTimeslot: string | null) => void
    sharedTimeslot?: string | null
}

type StateProps = Entity<GraphEntity | null> & {
    navigator: Navigator
    parameters: { [key: string]: string }
    tidewaysContext: TidewaysContext
}

type Props = StateProps & OwnProps

class Graph extends React.Component<Props> {
    private nodes: { chart: HTMLDivElement | null } = { chart: null }

    private redirect = (params, route) => {
        // if props.service is set, we are on the service-overview page (s=__all)
        // so when redirecting, we want to overwrite the service to make sure we land on the proper
        // page for selected events and especially snapshot views
        if (this.props.service) {
            this.props.tidewaysContext.setService(this.props.service)
            params['s'] = this.props.service
        }

        this.props.navigator.push(params, route)
    }

    public componentDidMount() {
        if (this.nodes.chart === null) {
            return
        }

        jQuery(this.nodes.chart).on('eventClicked', (e, event) => {
            this.redirect(
                { event: event.id, events: event.group.map((group: any) => group.id).join(',') },
                'XhprofOrganizationBundle.Application.show',
            )
        })

        jQuery(this.nodes.chart).on('rangeSelected', (e, dataSet, nextDataSet) => {
            this.redirect(Snapshot.fromDataSets(dataSet, nextDataSet).toParameters(), 'XhprofProfilerBundle.Snapshot.show')
        })

        jQuery(this.nodes.chart).on('rangeDelesect', e => {
            this.redirect({ date: null, end: null }, 'XhprofOrganizationBundle.Application.show')
        })
    }

    public render() {
        return (
            <div
                ref={element => {
                    this.nodes.chart = element
                }}
            >
                <TooltipGraph {...this.props} />
            </div>
        )
    }
}

export default connect<StateProps, OwnProps>((globalState: ApplicationState, props: OwnProps) => {
    const graph = getMonitorGraph(globalState, props.service)

    return {
        tidewaysContext: globalState.tidewaysContext,
        navigator: new Navigator(globalState.tidewaysContext.route),
        parameters: globalState.tidewaysContext.route.parameters,
        ...graph,
    }
})(Graph)
